import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_td = _resolveComponent("q-td")!
  const _component_audit_log_activity_message_field = _resolveComponent("audit-log-activity-message-field")!
  const _component_audit_log_operator_link = _resolveComponent("audit-log-operator-link")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    columns: _ctx.columns,
    rows: _ctx.items,
    flat: "",
    "row-key": "name"
  }, {
    "body-cell-actionName": _withCtx((scope) => [
      _createVNode(_component_q_td, {
        props: scope,
        style: {"text-transform":"capitalize"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.aliasForAction(scope.row['actionName'])), 1)
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-message": _withCtx((scope) => [
      _createVNode(_component_q_td, { props: scope }, {
        default: _withCtx(() => [
          _createVNode(_component_audit_log_activity_message_field, {
            keyMapper: _ctx.keyMapperInstance,
            message: scope.row['message']
          }, null, 8, ["keyMapper", "message"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-operator": _withCtx((scope) => [
      _createVNode(_component_q_td, { props: scope }, {
        default: _withCtx(() => [
          _createVNode(_component_audit_log_operator_link, {
            operator: scope.row['operator']
          }, null, 8, ["operator"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    _: 1
  }, 8, ["columns", "rows"]))
}